import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";


const notFoundimage = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/underconstruction/404-Error.webp"
const NotFound = () => {
  return (
    <div className="notfound-wrapper">
      {/* Left side with illustration (hidden on mobile) */}
      <section className="notfound-side">
        <img
          src={notFoundimage}
          alt="404 Illustration"
        />
      </section>

      {/* Right side with text */}
      <section className="notfound-main">
        <h1 className="notfound-title">404</h1>
        <h2 className="notfound-subtitle">Page Not Found</h2>
        <p className="notfound-message">
          Oops! The page you are looking for doesn’t exist or has been moved.
        </p>
        <Link to="/" className="notfound-button">
          Go Back Home
        </Link>
      </section>
    </div>
  );
};

export default NotFound;